const common = {
  "nav.home": "Home",
  "nav.advantages": "Advantages",
  "nav.testimonials": "Testimonials",
  "nav.pricing": "Pricing",
  "nav.contact": "Contact",
  "nav.dashboard": "Dashboard",
  "nav.signIn": "Sign In",
  "nav.logout": "Logout",
  "nav.toggleMenu": "Toggle menu",
  "nav.profile": "Profile",
  "nav.language": "Language",
  "footer.tagline": "Stay ahead of the curve",
  "footer.description": "Get updates on new features, industry insights, and tips on showcasing your advantages effectively.",
  "footer.newsletter.placeholder": "Type your message...",
  "footer.newsletter.subscribe": "WhatsApp",
  "footer.navigation": "Navigation",
  "footer.contact": "Contact",
  "footer.location": "Location",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms",
  "footer.copyright": "© 2026 Wyzon. All rights reserved.",
  "footer.address": "123 Innovation Drive, San Francisco, CA 94102",
  "footer.phone": "+20 109 9289 280",
  "footer.email": "sales@debugin.com",
  "loading": "Loading...",
  "error.generic": "Something went wrong",
  "button.tryAgain": "Try Again",
  "button.back": "Back",
  "button.submit": "Submit",
  "button.cancel": "Cancel",
  "language.en": "English",
  "language.ar": "العربية",
  "direction": "ltr",
  "plan.basic": "Basic",
  "plan.pro": "Pro",
  "plan.enterprise": "Enterprise",
};

export default common;